import React, { useEffect, useRef, useState } from "react";
import "./OffresContainer.scss";
import Offre from "../Offre/Offre";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { updatePagination } from "Redux/Actions/paginationActions";
// import Pagination from "Components/Pagination/Pagination";
import { FaChevronRight } from "react-icons/fa";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import OffreSearchBar from "Components/Offres/OffreSearchBar/OffreSearchBar";
import { Accordion, AccordionTab } from "primereact/accordion";
import { formatDate } from "Services/functions";
import { useFetchGetPagination } from "Services/api";
import { updateOffers } from "Redux/Actions/offersActions";
import { updateMenu } from "Redux/Actions/menuActions";
import { updateAuth } from "Redux/Actions/authActions";
import ModalConnexion from "Components/Modal/ModalConnexion/ModalConnexion";
import TempPagination from "Components/Pagination/TempPagination";
import Loader from "Components/Loader/loader";
/**
 * permet d'afficher un container avec les offres d'emploi de l'api
 * si un nombre d'offres est saisi dans les props, la pagination ne sera pas affichée, un bouton la remplacera
 * et seulement le nombre d'offres saisi sera affiché
 * permet d'avoir un affichage différent pour l'accueil et les autres pages d'offres
 * Les offres affichées doivent obligatoirement avoir le label "publiée" dans leur objet offer_status_id
 * La vérification se fait grâce à des filters directement avant la fonction array.prototype.map()
 */
const OffresContainer = (props) => {
  const [visibleModal, setVisibleModal] = useState(false);
  const [loginVisible, setLoginVisible] = useState(false);
  const [, setClickedOfferId] = useState(null);
  const [, setClickedUniversityId] = useState(null);
  const [offersUrl, setOffersUrl] = useState(props.queryUrl ?? null);

  // Gestion des offres affichées avec pagination
  const offersQuery = useFetchGetPagination(
    offersUrl,
    props.auth.token,
    props.handleUpdateOffers
  );

  useEffect(() => {
    if (props.queryUrl && props.queryUrl !== offersUrl) {
      setOffersUrl(props.queryUrl);
    }
  }, [props.queryUrl]);

  const offresContainerRef = useRef(null);
  const clickOutsideRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        clickOutsideRef.current &&
        !clickOutsideRef.current.contains(event.target)
      ) {
        props.handleUpdateOffers({
          motsClés: "",
          secteur: [],
          domaine: [],
          lieu: "",
          typeContrat: [],
          categorieOffre: [],
          niveauEtudes: [],
          isSearched: false,
          currentSearch: "",
        });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [clickOutsideRef]);

  useEffect(() => {
    return () => {
      props.handleUpdateOffers({ dataFromPagination: null });
    };
  }, []);

  useEffect(() => {
    if (
      props.states.statesData.length > 0 &&
      (!props.queryUrl || props.nbOffre === 12)
    ) {
      let url = null;
      //? Remise à zéro des informations de paginations pour ne pas interférer les affichages des autres pages
      if (props.offers.currentSearch !== "") {
        url = new URL(`${process.env.REACT_APP_BASE_URL_API}/offers`);
        url.search = props.offers.currentSearch.search;
        url.searchParams.set("page", 1);
        props.handleUpdateOffers({ isSearched: true });
      } else {
        url = new URL(`${process.env.REACT_APP_BASE_URL_API}/offers`);
        url.searchParams.set("order[modifiedAt]", "desc");
        url.searchParams.append("page", 1);
        url.searchParams.append(
          "state",
          props.states.statesData.find(
            (status) => status.statusLabel === "Publié"
          ).id
        );
        props.nbOffre && url.searchParams.set("itemsPerPage", props.nbOffre);
      }
      setOffersUrl(url);
    }
  }, [props.states.statesData.length]);

  return (
    <div
      className="article_offre"
      id="article_offre"
      style={{ backgroundColor: "#FFF" }}
      ref={clickOutsideRef}
    >
      <div className="article_offre__container">
        <h1 className="h1_trait_dessus">{props.title}</h1>
        {props.subTitle && <p className="sous_titre_offre">{props.subTitle}</p>}
        {!props.nbOffre &&
          (!props.offers.isSearched ? (
            <p>
              Les {offersQuery.totalItems || 0} dernières{" "}
              {offersQuery.totalItems > 0 ? "offres" : "offre"}
            </p>
          ) : (
            offersQuery && (
              <p>
                {offersQuery.totalItems}{" "}
                {offersQuery.totalItems.length > 0
                  ? "offres correspondent "
                  : "offre correspond "}{" "}
                à vos critères
              </p>
            )
          ))}
      </div>
      {!props.nbOffre && (
        <>
          <div className="offre_search_bar__filtres">
            <OffreSearchBar id="navbar_desktop" setUrl={setOffersUrl} />
          </div>
          <Accordion
            expandIcon="pi pi-sliders-h"
            collapseIcon="pi pi-sliders-h"
          >
            <AccordionTab header="Fitres de recherche">
              <OffreSearchBar id="navbar_desktop" setUrl={setOffersUrl} />
            </AccordionTab>
          </Accordion>
        </>
      )}
      <div className="article_offre__offres" ref={offresContainerRef}>
        {offersQuery?.loaded ? (
          offersQuery.data.length > 0 ? (
            (offersQuery.data || []).slice(0, 50).map((offre, index) =>
              props.nbOffre && props.nbOffre != 20 ? (
                index < props.nbOffre &&
                (props.auth.isConnected ? (
                  <Offre
                    categorie={index}
                    url={offre?.imageUrl || offre?.nexusImageUrl || "img1"}
                    nexusUrl={offre?.nexusImageUrl}
                    offreDetails={offre}
                    date={formatDate(
                      offre.postedAt?.date || offre.postedAt,
                      "."
                    )}
                    accessibleForDisabled={offre.accessibleForDisabled}
                    key={offre.id}
                  />
                ) : (
                  <Offre
                    key={offre.id}
                    categorie={index}
                    url={offre?.imageUrl || offre?.nexusImageUrl || "img1"}
                    nexusUrl={offre?.nexusImageUrl}
                    offreDetails={offre}
                    date={formatDate(
                      offre.postedAt?.date || offre.postedAt,
                      "."
                    )}
                    accessibleForDisabled={offre.accessibleForDisabled}
                    onClick={() => {
                      setLoginVisible(true);
                      setClickedUniversityId(
                        offre.universityId || offre.university.id
                      );
                      setClickedOfferId(offre.id);
                    }}
                  />
                ))
              ) : (
                <Offre
                  key={offre.id}
                  categorie={index % 4}
                  url={offre?.imageUrl || offre?.nexusImageUrl || "img1"}
                  nexusUrl={offre?.nexusImageUrl}
                  offreDetails={offre}
                  date={formatDate(offre.postedAt?.date || offre.postedAt, ".")}
                  accessibleForDisabled={offre.accessibleForDisabled}
                />
              )
            )
          ) : (
            <span>Aucune offre ne correspond à votre recherche</span>
          )
        ) : (
          <Loader />
        )}
      </div>

      <div className="article_offre__button">
        {props.nbOffre ? (
          <BtnBleu
            btnTexte={props.bouton}
            btnAction={() => {
              props.bouton === "Voir toutes les offres d'emploi" &&
                props.handleUpdateMenu({
                  activeItemOffre: props.items.itemsOffre.findIndex(
                    (item) => item.label == "Trouver une offre"
                  ),
                });
              if (props.auth.userConnected != null) {
                window.location.href = "./offres";
              } else {
                setVisibleModal(true);
              }
            }}
          >
            <FaChevronRight />
          </BtnBleu>
        ) : (
          <TempPagination
            result={offersQuery}
            refItemParent={offresContainerRef}
            rows={50}
          />
        )}
      </div>

      {visibleModal && (
        <ModalConnexion
          visibleModal={visibleModal}
          setVisibleModal={setVisibleModal}
        />
      )}

      {loginVisible && (
        <ModalConnexion
          setVisibleModal={setLoginVisible}
          visibleModal={loginVisible}
        />
      )}
    </div>
  );
};

OffresContainer.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  bouton: PropTypes.string,
  nbOffre: PropTypes.number,
  sousTitre: PropTypes.bool,
  offers: PropTypes.any,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
  handleUpdateOffers: PropTypes.func,
  handleUpdateMenu: PropTypes.func,
  handleUpdateAuth: PropTypes.func,
  sauvegarde: PropTypes.bool,
  items: PropTypes.object,
  auth: PropTypes.object,
  states: PropTypes.object,
  queryUrl: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  offers: state.offers,
  pagination: state.pagination,
  items: state.items,
  states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => dispatch(updatePagination(value)),
  handleUpdateOffers: (offers) => dispatch(updateOffers(offers)),
  handleUpdateMenu: (value) => dispatch(updateMenu(value)),
  handleUpdateAuth: (value) => dispatch(updateAuth(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OffresContainer);
